import python from "src/assets/Images/python-svgrepo-com.svg";
import tensorflow from "src/assets/Images/tensorflow-svgrepo-com.svg";
import django from "src/assets/Images/django-svgrepo-com.svg";
import fastapi from "src/assets/Images/api-svgrepo-com.svg";
import numpy from "src/assets/Images/numpy-svgrepo-com.svg";
import flutter from "src/assets/Images/flutter-svgrepo-com.svg";
import firebase from "src/assets/Images/firebase-svgrepo-com.svg";
import native from "src/assets/Images/react-svgrepo-com.svg";
import swift from "src/assets/Images/swift-svgrepo-com.svg";
import dart from "src/assets/Images/dart.svg";
import java from "src/assets/Images/java-svgrepo-com.svg";
import springboot from "src/assets/Images/spring-boot-svgrepo-com (1).svg";
import post from "src/assets/Images/postgresql-logo-svgrepo-com.svg";
import redis from "src/assets/Images/redis-svgrepo-com.svg";
import figma from "src/assets/Images/figma-svgrepo-com.svg";
import react from "src/assets/Images/react-svgrepo-com.svg";
import tailwind from "src/assets/Images/tailwindcss-icon-svgrepo-com.svg";
import framer from "src/assets/Images/framer-motion.svg";
import selemium from "src/assets/Images/selenium-svgrepo-com.svg";
import postman from "src/assets/Images/postman-icon-svgrepo-com.svg";
import jmeter from "src/assets/Images/apachejmeter-svgrepo-com.svg";
import cypress from "src/assets/Images/cypress-1.svg";
import linux from "src/assets/Images/linux-svgrepo-com.svg";
import docker from "src/assets/Images/docker-svgrepo-com.svg";
import kubernetes from "src/assets/Images/kubernetes-svgrepo-com.svg";
import aws from "src/assets/Images/aws-svgrepo-com (1).svg";
import github from "src/assets/Images/githubactions-svgrepo-com.svg";
import arjun from "src/assets/Images/arjun.jpeg";
import anusree from "src/assets/Images/anusree.png";
import abhishek from "src/assets/Images/abhishek.jpg";
import gayathri from "src/assets/Images/gayathri.jpeg";
import nandhana from "src/assets/Images/Nandhana.jpg";
import amjad from "src/assets/Images/amjad.jpeg";
import GJ from "src/assets/Images/GJ Logo.svg";
import girish from "src/assets/Images/Girish.jpg";
import ashli from "src/assets/Images/Ashli V P.jpg";
import sooraj from "src/assets/Images/Sooraj.jpg";
import shamil from "src/assets/Images/Shamil Darwish.jpg";
import kiran from "src/assets/Images/Kiran.jpg";
import sulthana from "src/assets/Images/Sulthana.jpg";

import { Link } from "react-router-dom";

// Mock data for GJ SkillBay Labs Landing Page
export const mockData = {
  // Hero section stats
  stats: {
    learnersTraned: "100+",
    liveProjects: "50+",
    parentCompanyExp: "10+",
    industryMentors: "15+",
    daysToPlacement: "Real Projects",
  },

  // Programs/Tracks
  programs: [
    {
      id: 1,
      title: "Academic Internship",
      duration: "2–12 weeks",
      schedule: "Offline ( Full- time and Part- time)",
      audience: "College Students",
      outcome:
        "An industry-aligned project portfolio, internship certification, and academic support documentation to meet college or university internship guidelines",
      description:
        "Gain practical industry exposure alongside your academic studies. Work on structured, real-world projects under expert supervision while fulfilling institutional internship requirements",
      features: [
        "Faculty- and industry-guided mentorship",
        "Academic project assignments",
        "Weekly progress reviews",
        "Internship completion certificate",
      ],
      cta: "Apply for Academic Internship",
    },
    {
      id: 2,
      title: "Buddy Training",
      duration: "16 Weeks",
      schedule: "Offline",
      audience: "Graduates & Job Seekers",
      outcome:
        "Industry-ready technical skills, a project-backed portfolio, and structured career guidance aligned with real-world software development practices",
      description:
        "Mentor-led, collaborative training focused on real-world projects, sprint-based learning, and practical skill development",
      features: [
        "Daily standups",
        "Live sprints",
        "Code reviews",
        "Mock interviews",
        "Placement support",
      ],
      cta: "Apply for Buddy Training ",
    },
  ],

  // Domain specializations
  domains: [
    {
      id: 1,
      title: "Python & AI Development",
      stack: "Python + Machine Learning",
      projects: [
        "Machine Learning Model Deployment",
        "Data Analytics Dashboard",
        "AI Chatbot Application",
        "More industry-focused projects",
      ],
      roles: ["Python Developer", "AL/ML Engineer", " AI Developer"],
      tools: [
        { name: "Python", icon: python },
        { name: "TensorFlow", icon: tensorflow },
        { name: "Django", icon: django },
        { name: "FastAPI", icon: fastapi },
        { name: "NumPy", icon: numpy },
      ],
      image: "https://images.unsplash.com/photo-1498050108023-c5249f4df085",
      img: python,
    },
    {
      id: 2,
      title: "Mobile App Development",
      stack: "Flutter + Native",
      projects: [
        "Food Ordering Mobile App",
        "Parking App with Maps Integration",
        "Push Notification System",
        "More real-world apps",
      ],
      roles: [
        "Mobile App Developer",
        "Flutter Developer",
        "Android Developer",
        "IOS Developer",
      ],
      tools: [
        { name: "Flutter", icon: flutter },
        { name: "Firebase", icon: firebase },
        { name: "React Native", icon: native },
        { name: "Swift", icon: swift },
        { name: "Dart", icon: dart },
      ],
      image: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c",
    },
    {
      id: 3,
      title: "Java Enterprise Development",
      stack: "Java + Microservices",
      projects: [
        "Banking Management System",
        "Inventory & ERP Modules",
        "Secure Payment Gateway",
        "Enterprise-level projects",
      ],
      roles: ["Java Developer", "Backend Engineer", ,],
      tools: [
        { name: "Java", icon: java },
        { name: "Spring Boot", icon: springboot },
        { name: "PostgreSQL", icon: post },
        { name: "Redis", icon: redis },
      ],
      image: "https://images.unsplash.com/photo-1579403124614-197f69d8187b",
    },
    {
      id: 4,
      title: "UX/UI Design & Frontend",
      stack: "Design + React",
      projects: [
        "Design System Creation",
        "Mobile App UI Design",
        "SaaS Dashboard Interfaces",
        "Creative design projects",
      ],
      roles: ["UI Designer", "UX Designer", "UI/UX Developer"],
      tools: [
        { name: "Figma", icon: figma },
        { name: "React", icon: react },
        { name: "Tailwind CSS", icon: tailwind },
        { name: "Framer Motion", icon: framer },
      ],
      image: "https://images.unsplash.com/photo-1551650975-87deedd944c3",
    },
    {
      id: 5,
      title: "QA & Test Automation",
      stack: "Testing + Automation",
      projects: [
        "Test Automation Framework",
        "API Testing Suite",
        "Performance & Load Testing",
        "Quality engineering projects",
      ],
      roles: ["QA Engineer", "Test Automation Engineer", "Quality Analyst"],
      tools: [
        { name: "Selenium", icon: selemium },
        { name: "Postman", icon: postman },
        { name: "JMeter", icon: jmeter },
        { name: "Cypress", icon: cypress },
      ],
      image: "https://images.unsplash.com/photo-1610563166150-b34df4f3bcd6",
    },
    {
      id: 6,
      title: "DevOps Engineering",
      stack: "AWS + Docker",
      projects: [
        "CI/CD Pipeline Implementation ",
        "Cloud Infrastructure Setup ",
        "Containerized Application Deployment ",
        "Production-grade DevOps projects ",
      ],
      roles: ["DevOps Engineer ", "Cloud Engineer ", "CI/CD Engineer"],
      tools: [
        { name: "Linux", icon: linux },
        { name: "Docker", icon: docker },
        { name: "Kubernetes", icon: kubernetes },
        { name: "AWS", icon: aws },
        { name: "GitHub Actions", icon: github },
      ],
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f",
    },
  ],

  // Mentors
  mentors: [
    {
      id: 1,
      name: "Girish Kumar",
      role: "Lead - Mobile App Development",
      company: "GJ Global",
      expertise: [
        "Flutter",
        "Dart",
        "Android",
        "IOS",
        "Firebase",
        "REST",
        "API Integration",
      ],
      image: girish,
    },

    {
      id: 2,
      name: "Ashli V P",
      role: "Lead - Java Development",
      company: "GJ Global",
      experience: "8+ years",
      expertise: [
        "Java",
        "Spring Boot",
        "Microservices",
        "REST APIs",
        "Database Integration",
      ],
      image: ashli,
    },
    {
      id: 3,
      name: "Sooraj K",
      role: "Lead - DevOps Engineering",
      company: "GJ Global",
      experience: "12+ years",
      expertise: [
        "DevOps ",
        " AWS",
        " CI/CD",
        " Docker",
        " Kubernetes",
        " Cloud Infrastructure",
      ],
      image: sooraj,
    },
    {
      id: 4,
      name: "Shamil Darwish",
      role: "Lead - AI Development",
      company: "GJ Global",
      experience: "10+ years",
      expertise: [
        "Python",
        "Django",
        "Flask",
        "REST APIs",
        "Data Processing",
        "Automation",
      ],
      image: shamil,
    },
    {
      id: 5,
      name: "Sulthana K T",
      role: "Lead - Software Quality Assurance",
      company: "GJ Global",
      experience: "8+ years",
      expertise: [
        "Manual Testing ",
        " Automation Testing",
        " Test Case Design",
        " Bug Tracking",
      ],
      image: sulthana,
    },
    {
      id: 6,
      name: "Kiranjith R",
      role: "Lead - UI/UX Development",
      company: "GJ Global",
      experience: "12+ years",
      expertise: [
        "UI Design",
        "UX Research",
        " Wireframing",
        " Prototyping",
        "Figma",
        "User-Centered Design",
      ],
      image: kiran,
    },
  ],

  // Testimonials
  testimonials: [
    {
      id: 1,
      name: "Arjun K",
      role: "React Developer",
      company: "GJ Global",
      content:
        "Through the GJ Skillbay program, I strengthened my front-end development skills with a strong focus on React. Hands-on training and live projects helped me master core React concepts, including components, hooks, state management, and API integration. This practical exposure enabled me to transition into a React Developer role, contributing effectively to production-level applications.",
      image: arjun,
      outcome: "Portfolio Ready",
      salary: "Industry Experience",
      link: "https://www.linkedin.com/in/arjun-b-1866b4309/",
    },
    {
      id: 2,
      name: "Anusree M",
      role: "Quality Analyst",
      company: "GJ Global",
      content:
        "Our QA internship was a great learning experience overall. We gained hands-on experience to real-time testing, bug reporting, and understanding actual project workflows. The team was supportive and open to guidance. At times, tight deadlines and limited documentation made learning a bit challenging, but those moments helped us improve our problem-solving and communication skills",
      image: anusree,
      outcome: "Job Ready Skills",
      salary: "Real Experience",
      link: "http://www.linkedin.com/in/anusree-mohan-667931208",
    },
    {
      id: 3,
      name: "Abhishek K B",
      role: "Flutter Developer",
      company: "GJ Global",
      content:
        "I completed my three-month Flutter internship at GJ Global IT Ventures, Calicut, where I received excellent one-to-one mentorship and continuous guidance. The mentors provided clear feedback and support that helped me strengthen my Flutter skills and understand real-time project development. Overall, it was a highly valuable learning experience that improved both my technical abilities and professional confidence.",
      image: abhishek,
      outcome: "Live Projects",
      salary: "Portfolio Built",
      link: "https://www.linkedin.com/in/abhishek-k-b-165882330",
    },
    {
      id: 4,
      name: "Gayathri R",
      role: "Java Devleoper",
      company: "GJ Global",
      content:
        "I completed a 3-month Java internship at GJ Global, where I gained hands-on experience in Java and Spring Boot. The training was practical and industry-focused, with excellent mentorship that helped me understand concepts clearly. I also worked on live projects, real-world exposure to backend development and application workflows. This internship was a valuable experience for my technical and professional growth.",
      image: gayathri,
      outcome: "Portfolio Ready",
      salary: "Industry Experience",
      link: "https://www.linkedin.com/in/gayathri-r-123491270 ",
    },
    {
      id: 5,
      name: "Nandhana",
      role: "UI/UX Designer",
      company: "GJ Global",
      content:
        "I am Nandhana sudheer completed UI/UX design at GJ Global IT Ventures,. My experience here has been good. I learned the basics of UI/UX design and how to use Figma for creating screens and prototypes. The trainers are helpful and explain things clearly. This course helped me improve my design skills and understand how real projects work. Overall, GJ Global IT Ventures is a good place to learn UI/UX design",
      image: nandhana,
      outcome: "Job Ready Skills",
      salary: "Real Experience",
      link: "https://www.linkedin.com/in/nandhana-sudheer-982a20325?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    },
    {
      id: 6,
      name: "Amjad.",
      role: "Python Developer",
      company: "GJ Global",
      content:
        "I am a Python AI Developer at GJ Global IT Ventures. My experience so far has been good and informative. I am learning the fundamentals of Python along with core AI concepts in a clear and structured way. The trainers are supportive and explain topics in an easy manner. The training focuses on practical learning and real-world applications. Overall, GJ Global IT Ventures is a good place to build skills in Python and AI development.",
      image: amjad,
      outcome: "Live Projects",
      salary: "Portfolio Built",
      link: "https://www.linkedin.com/in/amjad-e-17a462271/",
    },
  ],

  // Technology Partners & Tools
  technologyPartners: [
    {
      name: "GJ Global",
      logo: GJ,
    },
  ],

  // Process steps
  processSteps: [
    {
      step: 1,
      title: "Application Submission",
      duration: "5 minutes",
      description:
        "Share your background, career goals, and learning objectives",
    },
    {
      step: 2,
      title: "Screening and Onboarding ",
      duration: "2–4 Business Days ",
      description: "Initial assessment and mentor alignment process ",
    },
    {
      step: 3,
      title: "Technical Foundations ",
      duration: "8 weeks",
      description:
        "Core development tools, version control, and project management fundamentals. ",
    },
    {
      step: 4,
      title: "Live Projects and Agile Sprints ",
      duration: "7 weeks",
      description:
        "Design, develop, and iterate on real-world projects using agile methodologies ",
    },
    {
      step: 5,
      title: "Demo Day and Hiring Referrals ",
      duration: "1 week",
      description:
        "Present your project portfolio to hiring partners and receive structured referral opportunities",
    },
  ],

  // FAQ items
  faqs: [
    {
      question: "Do you offer guaranteed job placements?",
      answer:
        "GJ SkillBay does not guarantee job placements. However, we equip learners with industry-ready skills through real client projects, portfolio development, interview preparation, and networking support via GJ Global. ",
    },
    {
      question: " What is the duration of the programs?",
      answer: "• Academic internships typically ranges from 2 to 12 weeks ",
      answerTwo: "• Buddy Training is for 16 weeks. ",
    },
    {
      question: "Is the program suitable for beginners? ",
      answer:
        "Yes. The program is designed to support beginners by starting with strong foundational concepts. Learners receive continuous mentorship from experienced GJ Global developers and progressively advance to more complex, real-world projects. ",
    },
    {
      question:
        "What distinguishes GJ SkillBay from other training institutes?",
      answer:
        "GJ SkillBay is backed by GJ Global, an established software development company. Learners gain hands-on experience by working on real client projects under the guidance of experienced professionals, ensuring practical exposure beyond theoretical learning",
    },

    {
      question:
        "Will I work on real-world or live projects during the program? ",
      answer:
        "Yes. All GJ SkillBay programs are built around hands-on learning through live and real-world projects. Learners actively work on practical assignments using industry-standard tools, frameworks, and workflows under the guidance of experienced developers from GJ Global, ensuring exposure to real production environments ",
    },
    {
      question: "What kind of mentorship and support can learners expect? ",
      answer:
        "GJ SkillBay follows an exclusive Buddy Training model where each learner receives personalized guidance from an experienced industry professional. This includes regular progress reviews, real-time doubt resolution, code reviews, and continuous academic and career support throughout the program ",
    },
  ],

  // Contact info
  contact: {
    phone: "+91 98952 23307",
    phoneTwo: "+91 98955 53353",
    email: "skillbay@gjglobalsoft.com",
    address: "Govt Cyberpark, Kozhikode, Kerala, India",
  },

  // Urgency data
  urgency: {
    nextCohortDate: "February 15, 2026",
    seatsAvailable: 15,
    applicationDeadline: "February 10, 2026",
  },
};
